import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { SimpleListConfig } from 'src/app/models/simpleListConfig';
import { JournalService } from 'src/app/services/journal.service';
import { DatePipe } from '@angular/common';
import { LoaderService } from 'src/app/core/_config/loader.service';
import { JournalTypeService } from '../../../../services/journal-type.service';
import { JournalType } from '../../../../models/JournalType';
import { DOCUMENT } from '@angular/common';
import { AccountingJournalService } from '../services/accounting-journal.service';
import { AccountingJournalReportFilter } from '../models/accounting-journal-report-filter';
import { SessionBusiness } from 'src/app/core/_config/sessionBusiness.service';
import { Subscription } from 'rxjs';
import { MatDatepicker } from '@angular/material/datepicker';
import * as _ from 'lodash';
import * as _moment from 'moment';
import { Moment } from 'moment';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDateFormats } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';

const moment = _moment;

export const MY_APP_DATE_FORMATS: MatDateFormats = {
    parse: {
        dateInput: 'DD/MM/YYYY',
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@Component({
    templateUrl: './batch-export.component.html',
    styleUrls: ['./batch-export.component.scss'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_APP_DATE_FORMATS },
    ],
})
export class BatchExportComponent implements OnInit, OnDestroy {
    months = [
        { id: null, name: 'Todos' },
        { id: 1, name: 'Janeiro' },
        { id: 2, name: 'Fevereiro' },
        { id: 3, name: 'Março' },
        { id: 4, name: 'Abril' },
        { id: 5, name: 'Maio' },
        { id: 6, name: 'Junho' },
        { id: 7, name: 'Julho' },
        { id: 8, name: 'Agosto' },
        { id: 9, name: 'Setembro' },
        { id: 10, name: 'Outubro' },
        { id: 11, name: 'Novembro' },
        { id: 12, name: 'Dezembro' },
    ];

    journalStatusList: any[];

    userNameControl: FormControl = new FormControl(null);
    resOk: boolean = false;
    searchParams: any;
    simpleTableConfig: SimpleListConfig = {
        useSortable: true,
        useFilter: false,
        usePagination: true,
        page: {
            index: 0,
            size: 0,
            totalElements: 0,
        },
        selection: {
            type: 'single',
        },
        pageSize: [10, 20, 50],
        dateformat: 'dd/MM/yyyy',
        displayColumns: [
            {
                displayName: 'Data',
                field: 'date',
                type: 'date',
            },
            {
                displayName: 'Tipo de Lote',
                field: 'journalType',
                translateKey: 'JournalType',
            },
            {
                displayName: 'Itens',
                field: 'countItens',
            },
            {
                displayName: 'Mês',
                field: 'month',
            },
            {
                displayName: 'Ano',
                field: 'year',
            },
            {
                displayName: 'Número',
                field: 'number',
            },
            {
                displayName: 'Nome de Usuário',
                field: 'username',
            },
            {
                displayName: 'Status',
                field: 'journalStatus',
                type: 'journalStatus',
                translateKey: 'JournalStatus',
            },
            {
                field: 'action',
                type: 'action',
            },
        ],
        lineActions: [
            {
                action: (a) => this.onLineSelected(a),
                label: 'Detalhes',
                color: 'primary',
                icon: 'reorder',
            },
            {
                action: (a) => this.onSelectToPrint(a),
                label: 'Preview',
                color: 'primary',
                icon: 'print',
            },
        ],
    };

    formSearch: FormGroup = new FormGroup({});
    dataSource: any[] = [];
    journalTypes: Array<JournalType>;
    paramsReport: AccountingJournalReportFilter;

    private rangeChangesSubscription: Subscription;
    private formSearchChangesSubscription: Subscription;
    private readonly localStorageKeys = {
        dateOpen: 'batchExportDateOpen',
        dateClose: 'batchExportDateClose',
        formSearch: 'batchExportFormSearch',
    };

    yearPickerHelperControl = new FormControl(null);

    constructor(
        private journalService: JournalService,
        private journalTypeService: JournalTypeService,
        private cdref: ChangeDetectorRef,
        private router: Router,
        private builder: FormBuilder,
        private datePipe: DatePipe,
        private loaderService: LoaderService,
        @Inject(DOCUMENT) readonly document: Document,
        private accountingJournalService: AccountingJournalService,
        private sessionBusiness: SessionBusiness,
    ) {
        this.journalStatusList = new Array<any>();
        this.journalStatusList.push({ id: 0, name: 'All' });
        this.journalTypes = new Array<JournalType>();
        this.journalTypes.push({ batchTypeId: null, journalType: 'All', journalTypeId: null });

        const storedFormSearchString = localStorage.getItem(this.localStorageKeys.formSearch);

        let initialFormSearchValues = {
            userName: null,
            month: null,
            year: null,
            journalStatusId: this.journalStatusList[0].id,
            journalType: this.journalTypes[0],
            number: null,
        };

        if (storedFormSearchString) {
            try {
                const parsedFormSearch = JSON.parse(storedFormSearchString);
                initialFormSearchValues = { ...initialFormSearchValues, ...parsedFormSearch };
            } catch (e) {
                console.error('Error parsing formSearch from localStorage. Using defaults.', e);
            }
        }

        const storedDateOpenString: string | null = localStorage.getItem(this.localStorageKeys.dateOpen);
        const storedDateCloseString: string | null = localStorage.getItem(this.localStorageKeys.dateClose);

        const defaultOpenDate: Moment = moment().subtract(30, 'days');

        const initialDateOpen: Moment = storedDateOpenString ? moment(storedDateOpenString) : defaultOpenDate;
        const initialDateClose: Moment = storedDateCloseString ? moment(storedDateCloseString) : moment();
        this.paramsReport = new AccountingJournalReportFilter({});

        this.formSearch = this.builder.group({
            userName: new FormControl(initialFormSearchValues.userName),
            month: new FormControl(initialFormSearchValues.month),
            year: new FormControl(initialFormSearchValues.year),
            journalStatusId: new FormControl(initialFormSearchValues.journalStatusId),
            journalType: new FormControl(initialFormSearchValues.journalType),
            number: new FormControl(initialFormSearchValues.number),
            dateOpen: new FormControl(initialDateOpen ? moment(initialDateOpen) : null),
            dateClose: new FormControl(initialDateClose ? moment(initialDateClose) : null),
        });

        if (initialFormSearchValues.year) {
            this.yearPickerHelperControl.setValue(moment(String(initialFormSearchValues.year), 'YYYY'));
        }
    }

    ngOnInit(): void {
        this.getAllJournalTypes();
        this.searchParams = {
            params: {
                limit: this.simpleTableConfig.pageSize[0],
                page: 1,
            },
        };

        if (!!this.formSearch.value.journalType.journalTypeId) {
            this.searchParams.params.journalTypeId = this.formSearch.value.journalType.journalTypeId;

            if (!!this.formSearch.value.journalType.batchTypeId) {
                this.searchParams.params.batchTypeId = this.formSearch.value.journalType.batchTypeId;
            }
        }

        this.getJournalStatus();
        this.submitForm();
    }

    onSelectToPrint(element: any): void {
        if (element !== undefined) {
            this.paramsReport.journalId = element.journalId;
            this.paramsReport.legalEntityId = this.sessionBusiness.LegalEntityIdContext;
            this.paramsReport.journalType = this.journalTypes.filter(
                (p) => p.journalType === element.journalType,
            )[0].journalTypeId;
            this.paramsReport.printOption = 1;
            this.paramsReport.legalEntityGroup = false;
            this.paramsReport.periodGroup = false;
            this.paramsReport.accountsReceivingTypeGroup = false;
            this.paramsReport.serviceCodeGroup = false;
            this.paramsReport.toExport = false;
            this.paramsReport.accountingLotNumber = element.number;
            this.paramsReport.accountingLot = element.number;
        }

        this.journalService
            .getAccountingMonth(this.paramsReport.legalEntityId, element.month, element.year)
            .subscribe((p) => {
                this.paramsReport.accountingMonthId = p.data;
                this.accountingJournalService.getAccountingJournalByFilters(this.paramsReport).subscribe((pr) => {
                    const file = new Blob([pr], { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                });
            });
    }

    getJournalStatus() {
        this.journalService.getJournalStatus().subscribe((res) => {
            this.journalStatusList = this.journalStatusList.concat(res);
        });
    }

    submitForm() {
        this.searchParams = {
            params: {
                limit: this.simpleTableConfig.pageSize[0],
                page: 1,
            },
        };

        if (this.formSearch.value.userName != null) {
            this.searchParams.params.userName = this.formSearch.value.userName;
        }

        if (this.formSearch.value.dateOpen != null) {
            this.searchParams.params.initialDate = this.formSearch.value.dateOpen.format('YYYY-MM-DD');
        }

        if (this.formSearch.value.dateClose != null) {
            this.searchParams.params.endDate = this.formSearch.value.dateClose.format('YYYY-MM-DD');
        }

        if (this.formSearch.value.month != null) {
            this.searchParams.params.month = this.formSearch.value.month;
        }

        if (this.formSearch.value.year != null) {
            this.searchParams.params.year = this.formSearch.value.year;
        }

        if (this.formSearch.value.number != null) {
            this.searchParams.params.number = this.formSearch.value.number;
        }

        if (this.formSearch.value.journalStatusId != null && this.formSearch.value.journalStatusId !== 0) {
            this.searchParams.params.status = this.formSearch.value.journalStatusId;
        }

        if (this.formSearch.value.journalType && this.formSearch.value.journalType.journalTypeId) {
            this.searchParams.params.journalTypeId = this.formSearch.value.journalType.journalTypeId;

            if (this.formSearch.value.journalType.batchTypeId) {
                this.searchParams.params.batchTypeId = this.formSearch.value.journalType.batchTypeId;
            }
        }

        localStorage.setItem(this.localStorageKeys.formSearch, JSON.stringify(this.formSearch.value));
        localStorage.setItem(
            this.localStorageKeys.dateOpen,
            this.formSearch.value.dateOpen.format('YYYY-MM-DD') || '',
        );
        localStorage.setItem(
            this.localStorageKeys.dateClose,
            this.formSearch.value.dateClose.format('YYYY-MM-DD') || '',
        );

        this.getJournalsWithFilters();
    }

    getJournalsWithFilters() {
        this.resOk = false;
        this.loaderService.show();
        this.cdref.detectChanges();

        this.journalService.getJournals(this.searchParams).subscribe((res) => {
            this.simpleTableConfig.page.index = res.currentPage - 1;
            this.simpleTableConfig.page.totalElements = res.totalRecords;

            if (res.totalRecords > this.simpleTableConfig.pageSize[2]) {
                let index = this.simpleTableConfig.pageSize.indexOf(res.totalRecords);

                if (index === -1) {
                    this.simpleTableConfig.pageSize.push(res.totalRecords);
                }
            }

            this.dataSource = res.result;
            this.formatMonthName();
            this.resOk = true;
            this.loaderService.hide();
            this.cdref.detectChanges();
        });
    }

    formatMonthName() {
        this.dataSource.forEach((data) => {
            if (data.month) {
                data.month = this.months.find((x) => x.id == data.month).name;
            }
        });
    }
    onLineSelected(event: any) {
        this.router.navigate(['accounting/batch-details/', event.journalId]);
    }

    yearSelectedHandler(normalizedYear: moment.Moment, datepicker: MatDatepicker<moment.Moment>): void {
        const yearValue = normalizedYear.year();

        if (this.formSearch.get('year')) {
            this.formSearch.get('year')?.setValue(yearValue);
            this.yearPickerHelperControl.setValue(normalizedYear);
        }

        datepicker.close();
    }

    reloadTable(ev) {
        this.searchParams.params.page = ev.pageIndex + 1;
        this.searchParams.params.limit = ev.pageSize;
        this.simpleTableConfig.page.size = ev.pageSize;

        this.getJournalsWithFilters();
    }

    private getAllJournalTypes() {
        this.journalTypeService.getAll().subscribe((res) => {
            if (!!res) {
                const result = res.map(function (item) {
                    return {
                        batchTypeId: item.batchTypeId,
                        journalTypeId: item.journalTypeId,
                        journalType: item.description,
                    };
                });
                this.journalTypes = this.journalTypes.concat(result);

                const storedJournalType = this.formSearch.get('journalType').value;
                if (storedJournalType && storedJournalType.journalTypeId !== undefined) {
                    const selectedJournalTypeInList = this.journalTypes.find(
                        (jt) =>
                            jt.journalTypeId === storedJournalType.journalTypeId &&
                            jt.batchTypeId === storedJournalType.batchTypeId,
                    );
                    if (selectedJournalTypeInList) {
                        this.formSearch.get('journalType').setValue(selectedJournalTypeInList, { emitEvent: false });
                    }
                }
            }
        });
    }

    clearForm(): void {
        this.formSearch.reset();
        const defaultOpenDate: Moment = moment().subtract(30, 'days');

        this.formSearch.reset({
            userName: null,
            month: null,
            year: null,
            journalStatusId: this.journalStatusList[0].id,
            journalType: this.journalTypes[0],
            number: null,
            dateOpen: new FormControl(defaultOpenDate),
            dateClose: new FormControl(moment()),
        });

        this.yearPickerHelperControl.setValue(null);

        this.submitForm();
    }

    ngOnDestroy(): void {
        if (this.rangeChangesSubscription) {
            this.rangeChangesSubscription.unsubscribe();
        }
        if (this.formSearchChangesSubscription) {
            this.formSearchChangesSubscription.unsubscribe();
        }
    }
}
